import "./spinner.css";

function createSpinner(size) {
    var el = document.createElement('div');
    el.className = 'spinner-border' + (size === 'sm' ? ' spinner-border-sm' : '');
    el.setAttribute('role', 'status');
    return el;
}

window.showSpinner = function(element, text, size) {
    // Handle both selector strings and DOM elements
    const targetElement = typeof element === 'string' ? document.querySelector(element) : element;

    if (!targetElement) {
        console.warn('showSpinner: Element not found', element);
        return;
    }

    // Create spinner container
    const spinnerContainer = document.createElement('div');
    spinnerContainer.className = 'd-flex justify-content-center align-items-center my-5';

    spinnerContainer.appendChild(createSpinner(size));

    // Add text if provided
    if (text) {
        const textElement = document.createElement('span');
        textElement.className = 'ms-2';
        textElement.textContent = text;
        spinnerContainer.appendChild(textElement);
    }

    // Clear content and add spinner
    targetElement.innerHTML = '';
    targetElement.appendChild(spinnerContainer);

    return spinnerContainer;
}

/**
 * Shows a dimmed overlay with a spinner on top of the existing content.
 * Unlike showSpinner(), this preserves the element's content.
 */
window.showSpinnerOverlay = function(element, text) {
    const targetElement = typeof element === 'string' ? document.querySelector(element) : element;

    if (!targetElement) {
        console.warn('showSpinnerOverlay: Element not found', element);
        return;
    }

    // Ensure the target can contain an absolutely-positioned overlay
    if (getComputedStyle(targetElement).position === 'static') {
        targetElement.style.position = 'relative';
    }

    // Create overlay and fill it with a spinner
    const overlay = document.createElement('div');
    overlay.className = 'spinner-overlay';
    targetElement.appendChild(overlay);
    showSpinner(overlay, text);

    return overlay;
}
